<template>
  <!-- Menu -->
  <div class="navbar-container">
    <div class="navbar-header">
      <div class="logo-side-menu">
        <img src="@/assets/img/logo.svg" alt="Logo" title="Logo" />
      </div>
      <button class="close-btn" @click="toggleMobileMenu" aria-label="Close menu">
        <img class="close-icon" src="@/assets/svg/sideMenu/close_black.svg" alt="Close menu" />
      </button>
    </div>
    <div class="navbar">
      <ul class="nav-list">
        <li v-for="(item, index) in menuItems" :key="index" class="nav-item">
          <router-link class="nav-link" :to="item.to" active-class="active" exact>{{ item.label }}</router-link>
        </li>
        <!-- <li v-if="$i18n.locale !== 'pt'" class="nav-item">
          <a class="nav-link" href="#" @click.prevent="setLocale('pt')">{{ $t('header.pt') }}</a>
        </li>
        <li v-if="$i18n.locale !== 'en'" class="nav-item">
          <a class="nav-link" href="#" @click.prevent="setLocale('en')">{{ $t('header.en') }}</a>
        </li> -->
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuItems: [
          { id: 1, to: { name: 'HomePage' }, label: this.$t("header.home").toUpperCase() },
          { id: 2, to: { name: 'StaticInfos', params: { slug: 'história' } }, label: this.$t("header.history").toUpperCase() },
          { id: 4, to: { name: 'ourServicesPage' }, label: this.$t("header.services").toUpperCase() },
          { id: 6, to: { name: 'team' }, label: this.$t("header.team").toUpperCase() },
          { id: 7, to: { name: 'Gallery' }, label: this.$t("header.galeria").toUpperCase() },
          { id: 8, to: { name: 'Contact' }, label: this.$t("header.contacto").toUpperCase() }
      ],
    };
  },
  methods: {
    setLocale(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem('locale', locale);
      window.location.href = '/';
    },
    toggleMobileMenu() {
      this.$emit('close');
      document.body.classList.remove('overflow-hidden');
    }
  }
};
</script>

<style scoped>
/* Navbar Container */
.navbar-container {
  background-color: var(--primary-color);
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Navbar Header */
.navbar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  height: 80px;
}
.navbar {
  min-height: calc(100vh - 80px);
}
/* Logo */
.logo-side-menu img {
  height: 70px;
  width: auto;
}

/* Close Button */
.close-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

.close-icon {
  width: 25px;
  height: auto;
}

/* Navbar List */
.nav-list {
  list-style-type: none;
  padding: 0;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Navbar Items */
.nav-item {
  width: 100%;
  text-align: center;
}

.nav-item .nav-link {
  display: block;
  padding: 1rem 0;
  color: white;
  text-decoration: none;
  font-size: 1rem;
  transition: color 0.3s;
}
.nav-item .nav-link.active {
  font-weight: bold;
}
/* Specific navbar styles for active and hover states */
.nav-item .nav-link:not(.active) {
  opacity: 0.6;
}

.nav-item .nav-link:active {
  opacity: 1;
}

/* Adjustments for smaller screens */
@media (max-width: 992px) {
  .logo-side-menu img {
    height: 50px;
  }
  .close-icon {
    width: 20px;
  }
}
</style>
